var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.596.111H4.77v4.566h-.065L1.58.11H0V7.89h1.826V3.323h.054L5.038 7.89h1.558V.11zM7.777 7.889h5.393V6.396H9.604V4.74h3.276V3.248H9.604V1.604h3.555V.111H7.777V7.89zM16.167 7.889h1.772l1.418-4.791h.065l1.418 4.79h1.762L24.857.112h-2.02l-1.202 5.167h-.054L20.217.111h-1.665l-1.354 5.157h-.064L15.94.11h-2.02l2.246 7.778z",
    fill: "#fff"
  })));
}

export default SvgNewLogo;